import React, { useEffect, useState } from "react";
import PaymentMethodsImages from "../assets/payment-methods.png"; // Replace with your image
import { FaRupeeSign } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { GetGoodCallPlanListApi } from "../services/Api";
import { toast } from "react-toastify";

const GoodCallPlan = () => {
  const navigate = useNavigate();
  const [planOne, setPlanOne] = useState(null);
  const [planTwo, setPlanTwo] = useState(null);

  // Fetch the two plans after verification
  const fetchPlans = async () => {
    try {
      const response = await GetGoodCallPlanListApi();
      if (response.status === "success") {
        const [first, second] = response.data;
        setPlanOne(first);
        setPlanTwo(second);
      } else {
        toast.error(response?.message || "Failed to load plans");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load plans");
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  return (
    <div className="goodcall-plan-container">
      <div className="goodcall-plan-left">
        <h2 className="goodcall-plan-title">
          Pick the plan that’s <br />
          <span>Right for you</span>
        </h2>

        <p className="goodcall-plan-desc">
          The right care begins with the right choice. <br />
          Choose the plan that sees you, <br />
          not just your problem.
        </p>
        <p className="goodcall-plan-desc">
          It’s a gift to find good people. <br />
          It’s grace to hold onto them
        </p>

        {/* <h3 className="goodcall-plan-free-heading">Try our 100% free plan</h3>
        <div className="goodcall-plan-free-box">
          <p>
            Get started with our 2 counseling sessions <br />
            Absolutely free. No commitment requires
          </p>
          <button className="goodcall-plan-free-button">Signup for Free</button>
        </div> */}

        <div className="goodcall-plan-payments">
          <h4>Payment Methods</h4>
          <img
            src={PaymentMethodsImages}
            alt="Payment Methods"
            className="goodcall-plan-payments-img"
          />
          <p className="goodcall-plan-note">
            We accept Visa, American Express, Mastercard, Paypal and Crypto
          </p>
        </div>
      </div>

      <div className="goodcall-plan-right">
        {/* <div className="goodcall-plan-card">
          <div className="goodcall-plan-card-header">PAY AS YOU GO</div>
          <p className="goodcall-plan-card-sub">Charge Per Min</p>
          <div className="goodcall-plan-pricing">
            <div>
              <div className="goodcall-plan-pricing-amount-container">
                <FaRupeeSign size={20} />
                <p className="price">1</p>
              </div>
              <span className="label">Voice call</span>
            </div>
            <div>
              <div className="goodcall-plan-pricing-amount-container">
                <FaRupeeSign size={20} />
                <p className="price">4</p>
              </div>
              <span className="label">Video call</span>
            </div>
          </div>
          <button
            className="goodcall-plan-button-black"
            onClick={() => {
              navigate("/prime");
            }}
          >
            Start Now
          </button>
        </div> */}

        <div className="goodcall-plan-card-alt">
          <div className="goodcall-plan-card-header-light">UNLIMITED</div>
          <p className="goodcall-plan-card-sub">Charge Monthly</p>
          <div className="goodcall-plan-pricing">
            <div>
              <div className="goodcall-plan-pricing-amount-container">
                <FaRupeeSign size={20} />
                <p className="price white">{planOne ? planOne.amount : ""}</p>
              </div>

              <span className="label white">Voice call</span>
            </div>
            {/* <div>
              <div className="goodcall-plan-pricing-amount-container">
                <FaRupeeSign size={20} />
                <p className="price white">{planTwo ? planTwo.amount : ""}</p>
              </div>
              <span className="label white">Voice + Video</span>
            </div> */}
          </div>
          <button
            className="goodcall-plan-button-yellow"
            onClick={() => {
              navigate("/gcbuy");
            }}
          >
            Start Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default GoodCallPlan;
